import React from "react";
import style from "./termsAndPolicy.module.css";
import BackButton from "Components/Back/BackButton";
import { useNavigate } from "react-router-dom";

export const TermsAndConditions = () => {
  const navigate = useNavigate();
  return (
    <div className={style.container}>
      <div onClick={() => navigate(-1)} className={style.back}>
        <BackButton />
      </div>
      <div class="ql-editor" className={style.privacy}>
        <p style={{ textAlign: "center" }}>
          <strong>TERMS & CONDITIONS</strong>
        </p>
        <br />
        <br />
        <p>
          The following terms of use (“Terms of Use”) apply to you (“You”,
          “Your”) when You use our Talent Platform and our services (“Services)
          operated by Dimension NXG Private Limited (“DNXG”, “We”, “Us”, “Our”).
        </p>
        <br />
        <p>
          By accessing our Platform and using our Services, or each time you
          access or use DNXG’s Talent Platform online and/or mobile services and
          websites, including any mobile application and browser extension or
          plugin, regardless of where it is downloaded from (collectively, the
          “DNXG Apps”), and any software, service, feature, product, program and
          element (including e-mail messages, notifications, and other messages)
          provided by or on behalf of DNXG on or in connection with such
          services or websites, including any products, programs, and services
          described in these Terms and Conditions, You agree that you have read
          and understand the Terms and Conditions and also the Privacy Policy.
        </p>
        <br />
        <ol>
          <li>
            <strong>Personal Account :</strong>
            <ol>
              <br />
              <li>
                You can set up a personal account which allows You to track Your
                different applications to one or more Customers. For using the
                Talent Portal accessible on _____________, You may register from
                the email You received after applying or having Your consent
                requested. This is operated by DNXG under its own
                responsibility. The registration requires Your email address and
                a password. Afterwards, You will have the ability to log in with
                different options.
              </li>
              <br />
              <li>
                When You create a User Account with us, You guarantee us that
                You are entitled to create such User Account and that the
                information You provide is complete and accurate.
              </li>
              <br />
              <li>
                Furthermore, Your data will be used as described [link to “How
                Your Personal Data will be used” in the Privacy Policy”]
              </li>
              <br />
              <li>
                You are responsible for maintaining the confidentiality of Your
                User Account credentials at all times and You shall not share
                them with anyone else. You are responsible for all activities of
                Your User Account. In case of any unauthorised usage of Your
                User Account or security breach, You shall immediately notify
                us.
              </li>
              <br />
              <li>
                You are responsible for all information, materials, audio,
                video, text, images, and any other content you chose to include
                in Your Content. While DNXG does not claim any rights in respect
                of Your Content, you agree to provide DNXG with a limited,
                royalty-free, non- exclusive, transferable, worldwide, perpetual
                license to use, distribute and display all content posted by you
                while using the Services provided that such license is
                restricted to the sole purpose of enabling the DNXG to perform
                the Services.
              </li>
              <br />
              <li>
                You must ensure anything contained in Your Content is not
                unlawful, threatening, abusive, harassing, defamatory, libelous,
                deceptive, fraudulent, invasive of another’s privacy, and does
                not impersonate another person. You must also ensure that you
                have all rights necessary to use anything contained in Your
                Content. For example, and without limitation, there may be
                copyright owned by third parties in music, photographs, or other
                content that you choose to use in Your Content. You must ensure
                that you have the necessary rights to use such content before
                including it in Your Content. You should not upload any content
                that infringes the intellectual property rights of third parties
                (e.g. a name or trademark that is subject to any rights of
                another person or entity other than You, without appropriate
                authorization).
              </li>
              <br />
              <li>
                You agree to waive, and hereby do waive, any legal or equitable
                rights or remedies you have or may have against DNXG with
                respect to any such content. You acknowledge that while you may
                be exposed to such materials, you will hold DNXG harmless in
                relation thereto.
              </li>
              <br />
              <li>
                For more details about Your rights, please refer to Talent
                Platform’s privacy policy
              </li>
              <br />
              <li>
                You agree that You will not (please note that this list is not
                exhaustive):
                <ul>
                  <li>
                    Use DNXG Talent platform, services and Your Candidate Portal
                    for any purpose which is in breach of any applicable law or
                    statutory duty;
                  </li>
                  <li>
                    Use as a username any name that is offensive, vulgar or
                    obscene.
                  </li>
                  <li>Access a User Account used by another person;</li>
                  <li>
                    Use this Platform or the Services in any way that causes, or
                    may cause, damage to the Platform or Services or impairment
                    of the availability or accessibility of the Platform or
                    Services, or in any way which is unlawful, illegal,
                    fraudulent or harmful, or in connection with any unlawful,
                    illegal, fraudulent or harmful purpose or activity;
                  </li>
                  <li>
                    Use the Platform or Services to copy, store, host, transmit,
                    send, use, publish or distribute any material which consists
                    of (or is linked to) any spyware, computer virus, Trojan
                    horse, worm, keystroke logger, or other malicious computer
                    software;
                  </li>
                  <li>
                    Engage in any chain letters contests, junk email, pyramid
                    schemes, spamming, surveys or other duplicative or
                    unsolicited messages (commercial or otherwise);
                  </li>
                  <li>
                    Access or use Talent Portal and our services in any manner
                    that could damage, disable, overburden or impair any DNXG
                    server or the networks connected to any DNXG server;
                  </li>
                  <li>
                    Engage in act that causes compromise on the security or
                    integrity of the Platform, or attempt to reverse engineer,
                    modify or copy the Services;
                  </li>
                  <li>
                    Breach any applicable laws, rules or regulations, or
                    infringe upon any third party’s intellectual property rights
                    or other rights (including rights of privacy and publicity);
                  </li>
                  <li>
                    Harvest, collect, gather or assemble information or data
                    regarding other users without their consent;
                  </li>
                  <li>
                    Circumvent, disable or otherwise interfere with any
                    security-related features of the Platform or to jeopardize
                    or prejudice the operation, quality or integrity of the
                    Platform or the Services, or the operation, quality or
                    integrity of any telecommunications network;
                  </li>
                  <li>
                    Copy and/or take screenshots, make notes, use for free or
                    publish any material and content of this Platform or Service
                    in any other media;
                  </li>
                  <li>
                    Sub-license, assign or otherwise transfer the rights granted
                    to you in this agreement;
                  </li>
                  <li>
                    Use automatic means to access content or data from other
                    users;
                  </li>
                  <li>
                    Market any goods or services for any unauthorised purposes
                    (including advertising and making offers to buy or sell
                    goods or services).
                  </li>
                </ul>
              </li>
              <br />
            </ol>
          </li>
          <li>
            <strong>DNXG Obligations & Liability</strong>
            <ol>
              <br />
              <li>
                DNXG is not responsible for the activities, privacy statements
                or other any content of third- party websites, which are not
                controlled by DNXG. You agree that We shall not be liable,
                directly or indirectly, for any damage or loss caused or alleged
                to be caused by or in connection with use of or reliance on any
                content or services available on or through any third party
                websites or services.
              </li>
              <br />
              <li>
                DNXG does not take responsibility for any content posted by
                third parties while using the Services. DNXG expressly disclaims
                any and all liability in connection with Your Content. DNXG is
                not responsible for any loss, injury, or damage to any
                individual as a result either directly or indirectly of any
                information published on the Platform or made available through
                the Services.
              </li>
              <br />
              <li>
                DNXG Talent platform and all intellectual property rights in the
                services including software, hardware, products, processes,
                algorithms, user interfaces, know-how, technologies, designs and
                other tangible or intangible technical material or information
                made available by DNXG, is the exclusive property of DNXG or its
                suppliers.
              </li>
              <br />
              <li>
                All rights, title, and interest in and to the Platform and the
                Services, including any and all modifications and additions
                thereto, shall at all times remain with DNXG.
              </li>
              <br />
              <li>
                DNXG reserves the right (but not the obligation) in its sole
                discretion to refuse or remove any content that is available via
                the Services where it has any grounds to suspect non-compliance
                with these Terms.
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>Term & Termination</strong>
            <ol>
              <br />
              <li>
                The term of this Agreement will commence on the date that you
                first use, or otherwise register for, the Services (which
                includes the first time you visit our platform), and will
                continue in full effect until your account is cancelled and you
                cease using the Services.
              </li>
              <br />
              <li>
                You can terminate Your Profile – User Account at any time by
                going to Your Talent Portal settings.
              </li>
              <br />
              <li>
                DNXG may suspend or terminate these services including Your
                access to Your Portal with immediate effect if You violate these
                Terms of Use, if DNXG is legally required to do so, or if You
                object the validity of new Terms of Use. DNXG has no obligation
                to provide you with any notice of your breach of this Agreement
                but we may choose to provide notice, and an opportunity to cure
                such breach, in our sole discretion should we so choose.
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>Warranties</strong>
            <ol>
              <br />
              <li>
                Except as expressly provided in this Agreement and to the
                maximum extent permitted by the applicable law, DNXG website and
                services are provided on an “AS IS” basis and “AS AVAILABLE”,
                and DNXG makes no (and hereby disclaims all) other warranties,
                representations, or conditions, whether written, oral, express.
                Implied or statutory, including any implied warranties of
                merchantability, title, non-infringement, or fitness for a
                particular purpose, with respect to the use, misuse, or
                inability to use the services (in whole or in part) or any other
                services provided to You by DNXG. DNXG does not warrant that all
                errors can be corrected, or that operation of the Service shall
                be uninterrupted or error-free.
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>Limitation of Liability</strong>
            <ol>
              <br />
              <li>
                TO THE EXTENT LEGALLY PERMITTED UNDER APPLICABLE LAW, IN NO
                EVENT SHALL DNXG, OR ITS EMPLOYEES, AFFILIATES, SUPPLIERS, BE
                LIABLE FOR ANY DAMAGES, INCLUDING DAMAGES OR COSTS DUE TO LOSS
                OF PROFITS, DATA, USE OR GOODWILL, PERSONAL OR PROPERTY DAMAGE
                RESULTING FROM OR IN CONNECTION WITH THESE TERMS OF USE,
                REGARDLESS OF THE CAUSE OF ACTION OR THE THEORY OF LIABILITY,
                WHETHER IN TORT, CONTRACT, OR OTHERWISE.
              </li>
              <br />
              <p>
                Nothing in this Agreement will limit or exclude (i) any
                liability for death or personal injury resulting from
                negligence, (ii) limit or exclude any liability from fraud or
                fraudulent misrepresentation, (iii) limit any liabilities in any
                way that is not permitted under applicable law, or (iv) excluded
                any liability that may not be excluded under applicable law.
              </p>
              <br />
              <p>
                TO THE FULLEST EXTENT POSSIBLE BY LAW, DNXG’s MAXIMUM LIABILITY
                ARISING OUT OF OR IN CONNECTION WITH ANY USE OF DNXG’s WEBSITE
                OR TERMS OF USE, REGARDLESS OF THE CAUSE OF ACTION (WHETHER IN
                CONTRACT, TORT, BREACH OF WARRANTY OR OTHERWISE), WILL NOT
                EXCEED US$100.
              </p>
              <br />
              <p>
                Some jurisdictions may exclude certain of the above limitations
                in terms of warranties or liabilities. In this case, these above
                mentioned limitations may not apply to You.
              </p>
            </ol>
          </li>
          <br />
          <li>
            <strong>Indemnification</strong>
            <ol>
              <br />
              <li>
                DNXG agrees to defend, indemnify and hold you harmless from any
                damages, penalties, liabilities and costs resulting from third
                party claims that your use of the Platform as permitted in this
                Agreement infringe the patent rights, copyrights or other
                intellectual property rights of a third party.
              </li>
              <br />
              <li>
                You agree to defend, indemnify and hold us harmless from any
                damages, penalties, liabilities and costs resulting from third
                party claims arising from: (1) your breach of this Agreement;
                (2) your negligence or willful misconduct; or (3) any content
                you upload or share through the Platform;
              </li>
              <br />
              <li>
                Any indemnification obligations under this section are
                conditional upon the indemnified party: (a) promptly giving the
                indemnifying party written notice of the claim; (b) giving the
                indemnifying party sole control of the defense and settlement of
                the claim (provided that indemnifying party may not settle any
                claim unless it unconditionally releases the indemnified party
                of all liability), provided that the indemnified party may
                retain counsel to participate in the proceedings; and (c)
                providing the indemnifying party with all reasonable assistance,
                at the indemnifying party’s expense.
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>PAYMENT TERMS & REFUND POLICY:</strong>
            <ol>
              <br />
              <li>
                Payments for the services offered by the Platform shall be on a
                100% advance basis. The payment for service once subscribed to
                by you is not refundable and any amount paid shall stand
                appropriated. Refund, if any, will be at the sole discretion of
                DNXG.
              </li>
              <br />
              In the event of any suspension or termination of services on
              account of non-compliance of these Terms &amp; Conditions, any
              payment made to DNXG by you shall stand forfeited with immediate
              effect.
            </ol>
          </li>
          <br />
          <li>
            <strong>Non Endorsement & Release</strong>
            <ol>
              <br />
              <li>
                You acknowledge and agree that DNXG provide a suite of tools
                that enable you to participate in recruiting activities; as a
                result, we are not responsible for the accuracy, completeness,
                appropriateness, legality or applicability of any content or
                anything said, depicted, written or done by other users of the
                Services, including without limitation, any information that you
                may obtain by using the Services. We do not endorse anything
                contained in any content created by users of the Services, or
                any information, opinion, recommendation or advice expressed
                therein and you understand that you must evaluate and bear all
                risks associated with the use thereof. You hereby release and
                forever discharge us from any and all actions, causes of
                actions, claims, damages and liabilities that you may incur as a
                result of other users of the Services.
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>General</strong>
            <ol>
              <br />
              <li>
                DNGX’s failure to enforce any right or provision of these Terms
                of Use will not be considered a waiver of those rights.
              </li>
              <br />
              <li>
                All provisions of these Terms of Use that by their nature are
                intended to survive, shall survive any termination or expiration
                of these Terms of Use.
              </li>
              <br />
              <li>
                If any provision of this Agreement is determined to be
                unenforceable, invalid or in breach of any law by any tribunal,
                public body or court of competent jurisdiction for any reason
                whatsoever, the unenforceability or invalidity of such provision
                shall not affect the enforceability or validity of the remaining
                provisions of this Agreement and such unenforceable or invalid
                provision shall be severed from the remainder of this Agreement
                and as so modified this Agreement shall continue in full force
                and effect.
              </li>
              <br />
              <li>
                If any provision of these Terms is held to be invalid or
                unenforceable by a court, the remaining provisions of these
                Terms of Use will remain in effect. These Terms constitute the
                entire agreement between You and us regarding our services.
              </li>
              <br />
              <li>
                Nothing in these Terms of Use is to be construed as establishing
                or implying any partnership or joint venture between You and us
                not as appointing any party to be an agent or employee of the
                other.
              </li>
              <br />
              <li>
                This Agreement shall be governed by and construed in accordance
                with the Laws of India, without giving effect to its choice of
                laws rules and shall be submitted to the exclusive jurisdiction
                of the Courts of Mumbai.
              </li>
            </ol>
          </li>
          <br />
          <li>
            <strong>Changes to our Terms of Use</strong>
            <br />
            <br />
            <p>
              We reserve the right to change these Terms of Use at any time, so
              please check this page frequently for changes. We will notify You
              of significant changes to our Terms of Use by sending a notice to
              the primary email address specified in Your account or by placing
              a prominent notice on our site. Significant changes will go into
              effect two weeks following such notification. Non-material changes
              or clarifications will take effect immediately. We encourage You
              to check our site and these Terms of Use for updates.
            </p>
          </li>
          <br />
          <li>
            <strong>Notice</strong>
            <br />
            <br />
            <p>
              All notices to be given under this Agreement: (i) if to us, will
              be sent by email to legal@ajnalens.com; and (ii) if to you, will
              be sent by email to the email address that you provided to us when
              you registered for the Platform (or any other email address should
              you have updated your account to reflect such other email
              address.)
            </p>
          </li>
        </ol>
      </div>
    </div>
  );
};
